export const languages = [
  "Assamese",
  "Bengali",
  "English",
  "Gujarati",
  "Hindi",
  "Kannada",
  "Malayalam",
  "Marathi",
  "Odia",
  "Punjabi",
  "Sanskrit",
  "Tamil",
  "Telugu",
  "Urdu",
];

export const domainSubjects = [
  "Accountancy / Book Keeping",
  "Agriculture",
  "Anthropology",
  "Biology / Biological Studies / Biotechnology / Biochemistry",
  "Business Studies",
  "Chemistry",
  "Computer Science / Information Practices",
  "Economics / Business Economics",
  "Environmental Studies / Environmental Science",
  "Fine Arts / Visual Arts / Commercial Arts",
  "Geography / Geology",
  "History",
  "Home Science",
  "Knowledge Tradition - Practices in India",
  "Mass Media / Mass Communication",
  "Mathematics / Applied Mathematics",
  "Performing Arts (Dance, Drama, Music)",
  "Physical Education (Yoga, Sports)",
  "Physics",
  "Political Science",
  "Psychology",
  "Sociology",
];

export const generalTest = ["General Aptitude Test"];

export const allSubjects = {
  "Languages (List A)": languages,
  "Domain Subjects (List B)": domainSubjects,
  "General Test": generalTest,
};
